import React from 'react'
import { Button, Row } from 'antd'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LeftOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import ProfileDropdown from './ProfileDropdown'
import SuperAdminModeTag from './SuperAdminModeTag'
import { history } from '../utils/history'
import { USER_ROLE } from '../utils/enums'
import { RootState } from '../reducers'

interface Props {
	routeKey: string,
	computedMatch: {
		path: string
	}
}

const HeaderContent = ({ routeKey, computedMatch }: Props) => {
	const { t } = useTranslation('paths')
	const role = useSelector((state: RootState) => state.profile.profile.data?.role)

	const path = `paths:${routeKey}|path`
	const isAtRoot = computedMatch.path === t(path) || computedMatch.path === '/'
	const isPhoneOperator = role === USER_ROLE.PHONE_OPERATOR

	const justify = isAtRoot || isPhoneOperator ? 'end' : 'space-between'
	const backVisible = !isAtRoot && !isPhoneOperator

	return (
		<Row justify={ justify } align={ 'middle' } className={'mr-6'}>
			{backVisible && (
				<Button
					icon={ <LeftOutlined /> }
					type={ 'default' }
					style={ { margin: '20px' } }
					onClick={ history.goBack }
				>
					{ t('pages:Späť') }
				</Button>
			)}
			{/* Tag a profil drzime v spolocnom flex kontajneri, aby pri justify=space-between
			    (ked je vlavo tlacidlo Spat) neodletel Tag na opacnu stranu hlavicky */}
			<div style={ { display: 'flex', alignItems: 'center' } }>
				<SuperAdminModeTag />
				<ProfileDropdown />
			</div>
		</Row>
	)
}

HeaderContent.propTypes = {
	routeKey: PropTypes.string,
	computedMatch: PropTypes.shape({
		path: PropTypes.string
	})
}

HeaderContent.defaultProps = {
	routeKey: null,
	computedMatch: {
		path: null
	}
}

export default HeaderContent
